import type { MailListItemContextMenuProps as MailListItemContextMenuV9Props } from './components/MailListItemContextMenuV9';
import type { MailListItemContextMenuProps } from './components/MailListItemContextMenu';
import type * as lazyIndex from './lazyIndex';
import { createLazyComponent, type LazyComponent, LazyModule } from 'owa-bundling';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(
    () => import(/* webpackChunkName: "MailListItemContextMenu"*/ './lazyIndex'),
    { name: 'MailListItemContextMenu' }
);

// Delay loaded components
export const MailListItemContextMenu: LazyComponent<MailListItemContextMenuProps, unknown, void> =
    createLazyComponent(lazyModule, m => m.MailListItemContextMenu);

export const MailListItemContextMenuV9: LazyComponent<
    MailListItemContextMenuV9Props,
    unknown,
    void
> = createLazyComponent(lazyModule, m => m.MailListItemContextMenuV9);
